import type {
  IdMap,
  OrchestratedOfferingListingDetails,
  OfferingItem,
} from '@b-stock/fe-core/bstock-next/queries'

import { getRetailQuantityPrice } from '@/buyer-portal/components/features/offerings/OfferingDetailsLayout/OfferingForm/values'

export const getOfferAmount = ({
  listing,
}: {
  listing: OrchestratedOfferingListingDetails
}) => {
  const offeringItemsMap = listing.items.reduce<IdMap<OfferingItem>>(
    (acc, item) => {
      acc[item._id] = item
      return acc
    },
    {}
  )

  const userOfferAmount =
    listing.offering?.offerScope === 'ITEM'
      ? (listing.offers?.[listing.offers.length - 1]?.offer.quantities ?? [])
          .map((o) => {
            const item = offeringItemsMap[o.itemId]
            if (!item) return 0
            return getRetailQuantityPrice({
              offerAmountUnits: listing.offering?.offerAmountUnits,
              offerAmount: o.amount,
              offerQuantity: o.quantityMax,
              unitRetail: item.attributes.unitRetail,
              itemQuantity: item.quantity,
              contract: listing.contract,
              allowQuantityOverflow: false,
            })
          })
          .reduce<number>((x, y) => (isNaN(x) ? 0 : x) + (isNaN(y) ? 0 : y), 0)
      : listing.offering?.offerScope === 'LOT'
        ? (listing.offers?.[listing.offers.length - 1]?.offer.lotAmount ?? 0)
        : 0

  return userOfferAmount
}
